import { render, staticRenderFns } from "./Rotate.vue?vue&type=template&id=4b3b8956&"
import script from "./Rotate.vue?vue&type=script&lang=ts&"
export * from "./Rotate.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./Rotate.vue?vue&type=style&index=0&lang=stylus&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports